import React, { useState, useRef, useEffect } from "react";
import VisibilitySensor from "react-visibility-sensor";
import "./MapsIntroLayouts.css";

const MAPS_INTRO_DATA = {
  title: "Most Adaptive Pharmacy Software (MAPS)",
  description: "ClinTa MAPS stands out as the most adaptive pharmacy software in the market, tailored to meet the diverse needs of modern pharmacies. It adapts itself to enhance efficiency, accuracy, and customer satisfaction.",
  features: [
    "Online or Offline Availability",
    "Comprehensive System / POS",
    "Flexible Invoicing Interfaces",
    "Customizable Dashboards",
    "Smart Purchase Management",
    "Integrated or Manual Invoicing",
    "Variable Access Control",
    "Flexible Scaling Solutions",
  ],
};

function MapsIntroScrollable({ features, inView, isMobile }) {
  const maxH = isMobile ? "220px" : "none";
  const overflow = isMobile ? "auto" : "visible";

  return (
    <div
      className={`maps-bullets maps-bullets-numbered maps-bullets-scrollable ${inView ? "maps-bullets-in-view" : ""}`}
      style={{ maxHeight: maxH, overflowY: overflow }}
    >
      {features.map((item, idx) => (
        <div key={idx} className="maps-bullets-numbered-item" style={{ animationDelay: `${idx * 0.08}s` }}>
          <span className="maps-bullets-number-badge">
            <span className="maps-bullets-number-inner">{String(idx + 1).padStart(2, "0")}</span>
          </span>
          <span className="maps-bullets-numbered-text">{item}</span>
        </div>
      ))}
    </div>
  );
}

export function MapsIntroLayoutSelector({ data }) {
  const [inView, setInView] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const wasVisibleRef = useRef(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const handler = () => setIsMobile(mq.matches);
    handler();
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const handleVisibility = (visible) => {
    if (visible && !wasVisibleRef.current) {
      setInView(true);
      wasVisibleRef.current = true;
    }
  };

  const content = data || MAPS_INTRO_DATA;

  return (
    <VisibilitySensor onChange={handleVisibility} partialVisibility offset={{ bottom: 80 }}>
      <section id="about" className={`position-relative feature-section ptb-100 gray-light-bg maps-intro-section section-below-banner ${inView ? "maps-intro-in-view" : ""}`}>
        <div className="container maps-intro-wrapper">
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-10 mb-4" style={{ textAlign: "center" }}>
              <h2 className="web mb-3">{content.title}</h2>
              <p>{content.description}</p>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="maps-intro-bullets-wrap">
                <MapsIntroScrollable features={content.features} inView={inView} isMobile={isMobile} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </VisibilitySensor>
  );
}
